import { useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { getVariationDetails } from './getVariationDetails'

/**
 * @param {Object} variation
 * @returns {{ details: Array<Object>, lines: Array<string> }} - The labelled details
 * and their "label: value" lines
 */
function useVariationDetails(variation) {
  const t = useTranslation()

  return useMemo(() => {
    const details = getVariationDetails(variation, t)

    return { details, lines: details.map(({ label, value }) => `${label}: ${value}`) }
  }, [variation, t])
}

export default useVariationDetails
